"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RULA_COMMON_PLUGIN_NAME = void 0;
exports.RULA_COMMON_PLUGIN_NAME = "common-rula-event-plugin";
class RulaCommonPlugin {
    name = exports.RULA_COMMON_PLUGIN_NAME;
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    type = "enrichment";
    productArea;
    userId;
    userType;
    constructor(productArea, userType) {
        this.productArea = productArea;
        this.userType = userType;
    }
    async setup(_config) {
        return undefined;
    }
    async execute(event) {
        if (event.event_type === "$identify")
            return event;
        const userType = event.extra?.user_type || this.userType;
        const productArea = event.extra?.product_area || this.productArea;
        const pagePath = typeof window !== "undefined" ? window.location.pathname : "";
        const pageUrl = typeof window !== "undefined" ? window.location.href : "";
        event.event_properties = {
            ...event.event_properties,
            page_path: pagePath,
            page_url: pageUrl,
            product_area: productArea,
            user_type: userType,
        };
        return event;
    }
}
exports.default = RulaCommonPlugin;
//# sourceMappingURL=rula-common-plugin.js.map